<!-- App header -->
<template>
  <div class="app-header">
    <!-- TIP logo, routes to homepage -->
    <transition
      enter-active-class="animated slideInDown faster"
      leave-active-class="animated slideOutUp faster"
    >
      <div v-if="this.$store.state.headerVisible" class="image-wrapper row middle-xs">
        <img class="image-logo" src="../assets/logo.svg" @click="toHomepage" />
      </div>
    </transition>

    <!-- Rotating cube button for the side menu -->
    <transition
      enter-active-class="animated slideInDown faster"
      leave-active-class="animated slideOutUp faster"
    >
      <div v-if="this.$store.state.headerVisible" class="cube-wrapper row middle-xs">
        <rotating-cube v-if="$mq === 'sm'" class="menu-cube" :size="7" @click.native="toggleMenu" />
        <rotating-cube
          v-if="$mq === 'lg'"
          class="menu-cube"
          :size="2.5"
          @click.native="toggleMenu"
        />
      </div>
    </transition>
  </div>
</template>

<script>
export default {
  name: "AppHeader",
  methods: {
    toggleMenu() {
      this.$store.state.menuVisible = !this.$store.state.menuVisible;
    },
    toHomepage() {
      this.$router.push("/");
      this.$store.state.menuVisible = false;
    }
  }
};
</script>

<style scoped>
.white-background {
  position: fixed;
  height: var(--header-height);
  width: 100%;
  background-color: var(--white);
  z-index: 5;
}
.image-wrapper,
.links-wrapper,
.cube-wrapper {
  position: fixed;
  height: var(--header-height);
}
.image-wrapper {
  z-index: 11;
  left: 0;
}
.image-logo {
  margin-left: calc((6.5vw - 3.75vw) / 2);
  height: 3.75vw;
  cursor: pointer;
}
.links-wrapper {
  z-index: 6;
  right: 6.5vw;
}
.cube-wrapper {
  z-index: 11;
  right: 0;
}
.menu-cube {
  margin-right: calc((6.5vw - 2.5vw) / 2);
  cursor: pointer;
}
@media only screen and (max-width: 767px) {
  /* MOBILE */
  .image-logo {
    margin-left: calc((18.48888vw - 10.66666vw) / 2) !important;
    height: 10.66666vw !important;
  }
  .menu-cube {
    margin-right: calc((18.48888vw - 7vw) / 2) !important;
  }
}
</style>